export function centsToEurosFormattedPrice(cents: number): string {
  const euros = cents / 100

  const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'EUR',
  })

  return formatter.format(euros)
}

export const isNumber = (value: unknown): value is number => {
  return typeof value === 'number' && !isNaN(value)
}
